module.exports = __webpack_public_path__ + "img/chicken-pedigree.da48c24e.svg";